import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBusinesses } from "../../api";
import { Business } from "../../types";

const Businesses = () => {
  const [businesses, setBusinesses] = useState<Business[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBusinesses()
      .then((res) => {
        // The business data is nested under the 'data' property in the paginated response
        setBusinesses(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch businesses:", err);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div className="border-b border-gray-100 bg-white pb-16 pt-[120px] text-gray-900 md:pb-20 md:pt-[140px]">
        <div className="mx-auto max-w-[1400px] px-6 text-center lg:px-8">
          <div className="mb-6">
            <i className="fas fa-store text-5xl text-indigo-600 md:text-6xl"></i>
          </div>
          <h1 className="mb-4 text-4xl font-bold md:text-5xl lg:text-6xl">
            Community Business Directory
          </h1>
          <p className="text-lg text-gray-600 md:text-xl">
            Discover and support local businesses in our village
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] bg-white px-6 py-16 md:py-20 lg:px-8 lg:py-24">
        {loading ? (
          <p>Loading businesses...</p>
        ) : businesses.length > 0 ? (
          <div className="grid gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
            {businesses.map((business) => (
              <div
                key={business.id}
                className="transform overflow-hidden rounded-xl border border-gray-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                <div className="p-6">
                  <h3 className="mb-2 text-xl font-bold text-gray-900">
                    {business.name}
                  </h3>

                  {business.category && (
                    <p className="mb-3 inline-flex items-center gap-1 text-sm text-gray-600">
                      <i className="fas fa-tag text-red-500"></i>{" "}
                      {business.category}
                    </p>
                  )}

                  <p className="mb-4 line-clamp-3 text-gray-600">
                    {business.description.substring(0, 120)}...
                  </p>

                  <div className="flex items-center justify-between border-t border-gray-100 pt-4">
                    <div className="text-sm text-gray-500">
                      <i className="fas fa-user text-indigo-600"></i>{" "}
                      {business.user.firstname} {business.user.lastname}
                    </div>
                    <Link
                      to={`/businesses/${business.id}`}
                      className="group/link inline-flex items-center gap-2 font-bold text-indigo-600 hover:text-indigo-800"
                    >
                      View Details
                      <i className="fas fa-arrow-right transition-transform group-hover/link:translate-x-1"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="py-20 text-center">
            <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-gray-100">
              <i className="fas fa-store-slash text-5xl text-gray-400"></i>
            </div>
            <h2 className="mb-2 text-2xl font-bold text-gray-800">
              No Businesses Found
            </h2>
            <p className="text-gray-600">
              There are currently no businesses to display. Please check back
              later.
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default Businesses;
